import React, { useContext, useMemo } from "react";
import ReactECharts from "echarts-for-react";
import { FilterContext } from "../../../context/Filter";

// Memoize the chart so it rerenders only when props change
const Psfbarchart2 = React.memo(({ data = [], dataKey = "psf", label = "Score" }) => {
    const { selectedYear, setSelectedYear } = useContext(FilterContext);


    const yearOptions = [
        { label: "2020-2021", value: "2020-21" },
        { label: "2021-2022", value: "2021-22" },
        { label: "2022-2023", value: "2022-23" },
        { label: "2023-2024", value: "2023-24" },
        { label: "2024-2025", value: "2024-25" },
    ];

    const currentYear = selectedYear || yearOptions[0].value;
    const selectedStartYear = currentYear.split("-")[0];

    // Filter data only when `data` or `currentYear` changes
    const filteredData = useMemo(() => {
        if (!Array.isArray(data)) return [];
        return data.filter(item => item.key && item.key.startsWith(selectedStartYear));
    }, [data, selectedStartYear]);

    const categories = filteredData.length ? filteredData.map(item => item.key) : ["No Data"];
    const values = filteredData.length ? filteredData.map(item => item[dataKey] || 0) : [0];

    const getChartConfig = key => {
        switch (key) {
            case "psf": return { title: "PSF Score", color: "#3b82f6" };
            case "ces": return { title: "CES Score", color: "#10b981" };
            case "dssat": return { title: "DSSAT Score", color: "#ef4444" };
            default: return { title: label, color: "#3b82f6" };
        }
    };

    const config = getChartConfig(dataKey);

    const option = useMemo(() => ({
        tooltip: { trigger: "axis", axisPointer: { type: "shadow" } },
        grid: { left: "3%", right: "4%", bottom: "3%", containLabel: true },
        xAxis: {
            type: "category",
            data: categories,
            axisTick: { alignWithLabel: true },
            splitLine: { show: false },
        },
        yAxis: {
            type: "value",
            name: config.title,
            splitLine: { show: false },
        },
        series: [
            {
                name: config.title,
                type: "bar",
                barWidth: "60%",
                data: values,
                itemStyle: { color: config.color },
            },
        ],
    }), [categories, values, config]);

    return (
        <div className="bg-white p-4 rounded-lg shadow-md">
            <div className="flex justify-end mb-2">
                <select
                    value={currentYear}
                    onChange={e => setSelectedYear(e.target.value)}
                    className="border border-gray-300 rounded-md px-3 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white cursor-pointer"
                >
                    {yearOptions.map(option => (
                        <option key={option.value} value={option.value}>{option.label}</option>
                    ))}
                </select>
            </div>

            <ReactECharts option={option} style={{ height: "400px", width: "100%" }} />
        </div>
    );
});

export default Psfbarchart2;
